import type { Prototype } from "../prototype-types";

export const abbyMillsPrototypes: Prototype[] = [
  {
    id: "am-multi-minimum-progress-bar",
    name: "Multi Minimum Progress Bar",
    path: "/am/multi-minimum-progress-bar",
    description:
      "Exploring multi-brand minimum progress bar tiles for the retailer homepage",
    owner: "Abby Mills",
    createdAt: "2026-07-14",
    lastUpdated: "2026-07-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6d7e0630af4dd9c81d90cffeb966044967b059bf87f602f93782dc6b267f9528.png",
    creationTool: "cursor",
  },
  {
    id: "native-cart-order-summary",
    name: "Native Cart Order Summary",
    path: "/am/native-cart-order-summary",
    description: "Exploring ideas for the cart on native",
    owner: "Abby Mills",
    createdAt: "2026-05-19",
    lastUpdated: "2026-06-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "wip",
    platform: "mobile",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ab0fa3305575b825f7afe924c958359fcd8c62dffa891081cfd7aab0e19ca1ca.png",
    creationTool: "cursor",
  },
  {
    id: "orders-baseline-test",
    name: "Orders Baseline Test",
    path: "/am/orders-baseline-test",
    description: "Exploring how to get a good orders baseline in Cursor.",
    owner: "Abby Mills",
    createdAt: "2026-05-06",
    lastUpdated: "2026-05-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "wip",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/99db2a93b06fa1bf617f5c495e02dcf6c0b76961108491217e2cf4fed8699d35.png",
    creationTool: "cursor",
  },
  {
    id: "cursed-faire",
    name: "Cursed Faire",
    path: "/cursed-faire",
    description:
      "Skip the price sheet. Every order requires a live haggling session over Zoom with the brand's actual founder. They can refuse you for any reason, including vibes.",
    owner: "Abby Mills",
    createdAt: "2026-05-05",
    lastUpdated: "2026-05-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "wip",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6ef77ff8b2c4b246c54019103472b411dca1c9fd94ce6f9030a6b32eab9b071b.png",
    creationTool: "cursor",
  },
  {
    id: "my-orders-mental-model",
    name: "My Orders: batching 2.0",
    path: "/am/my-orders-mental-model",
    description:
      "Explore mental models for My Orders — organizing by arrival time instead of checkout date. Includes diagram and two page variants.",
    owner: "Abby Mills",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c734ad27a731d1ff70b33d3783870b0794e5dbe056e473a00790b75de289a8a7.png",
    creationTool: "claude-code",
  },
  {
    id: "fs-cart-conversion",
    name: "Faire Source Cart Conversion Explorations",
    path: "/am/fs-cart-conversion",
    description:
      "Exploring ways to help retailers complete their FS cart and add products they love. Two baseline variants: below minimum ($65) and above minimum ($200).",
    owner: "Abby Mills",
    createdAt: "2026-04-17",
    lastUpdated: "2026-04-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2c1bbd312fa81f5ccc44e8effe009ebc3b944139c121c4cd998dabd7bf442c69.png",
    creationTool: "claude-code",
  },
  {
    id: "baseline-hack-test",
    name: "Baseline Hack Test",
    path: "/am/baseline-hack-test",
    description: "Design exploration / experiment",
    owner: "Abby",
    createdAt: "2026-04-16",
    lastUpdated: "2026-04-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6b08baf6df4972f4aed713e2c28508dc3788907e4616da1df7cc648112ce4250.png",
    creationTool: "cursor",
  },
  {
    id: "watson-test",
    name: "Watson Test",
    path: "/am/watson-test",
    description: "Testing the watson skill installation",
    owner: "Abby",
    createdAt: "2026-04-07",
    lastUpdated: "2026-04-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8c67efbee932b4ea0fb58c5a2753768c76a5252c929b0a8bcd27790e1045bd52.png",
    creationTool: "cursor",
  },
  {
    id: "side-cart-exploration",
    name: "Side Cart Exploration",
    path: "/am/side-cart-exploration",
    description:
      "Exploring how the mini cart and side cart should work across Faire — search results with quick-add and PDP with brand-aware cart",
    owner: "Abby Mills",
    createdAt: "2026-04-06",
    lastUpdated: "2026-04-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/49dfd21dd8973aac1ab93cf261452df41b16290e6a559185b369eb31d77e5e37.png",
    creationTool: "cursor",
  },
  {
    id: "test-with-james",
    name: "Test with James",
    path: "/am/test-with-james",
    description: "A test for local to cloud workflow",
    owner: "Abby Mills",
    createdAt: "2026-04-06",
    lastUpdated: "2026-04-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2726dd58d57d4905a6dfb298957c9ce1d4856d6a3d6476f917800098ed20096e.png",
    figmaLink:
      "https://www.figma.com/design/aT7aCzjftm3ojYiYkaoKvA/%F0%9F%AA%B5-Faire-Source--Post-MVP?node-id=14226-116967&m=dev",
    creationTool: "cursor",
  },
  {
    id: "my-orders-batching",
    name: "My Orders for Batching",
    path: "/am/my-orders-batching",
    description:
      "Redesign My Orders to support batched orders for Faire Source. Explores shipment-first vs brand-first grouping approaches.",
    owner: "Abby Mills",
    createdAt: "2026-03-19",
    lastUpdated: "2026-03-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6e721244d62013e65c1ac794f156b88d2a70625de7c95e28aa7bac0ad1393922.png",
    creationTool: "cursor",
  },
  {
    id: "faire-source-non-insiders",
    name: "Faire Source for Non-Insiders",
    path: "/am/faire-source-non-insiders",
    description:
      "Faire Source shop experience for non-Insider retailers. Implemented from Figma design.",
    owner: "Abby",
    createdAt: "2026-03-16",
    lastUpdated: "2026-03-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/80e88d38ae157f84dc7c64719195809981bfcc764a808627703bc9a5e245726b.png",
    figmaLink:
      "https://www.figma.com/design/GwtrzIyly2zK1Yl2FAFi1I/%F0%9F%94%91-Faire-Source--for-Non-Insiders?node-id=8542-33596&m=dev",
    creationTool: "cursor",
  },
  {
    id: "faire-source-about",
    name: "Faire Source About Tab",
    path: "/am/faire-source-about",
    description:
      "About tab of the Faire Source shop page with benefits, testimonials, FAQ, and bestsellers.",
    owner: "Abby Mills",
    createdAt: "2026-03-31",
    lastUpdated: "2026-03-31",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b8cf80a0d5cafcad78aaa34cd7be8641faa593258c346c2113afb590bb4a011d.png",
    figmaLink:
      "https://www.figma.com/design/aT7aCzjftm3ojYiYkaoKvA/%F0%9F%AA%B5-Faire-Source--Post-MVP?node-id=14014-8106&m=dev",
    creationTool: "cursor",
  },
  {
    id: "atc-toast-non-pdp",
    name: "ATC Toast Non-PDP",
    path: "/am/atc-toast-non-pdp",
    description: "ATC toast on non PDP surfaces",
    owner: "Abby",
    createdAt: "2026-02-20",
    lastUpdated: "2026-04-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/0db95c547b1da9a3bb84d90fd08a59e440d56f06a6256a5e61807f588fc8ac7f.png",
    project: "ATC Shopping Loops",
    creationTool: "cursor",
  },
  {
    id: "faire-source-atc-shopping-loop-native",
    name: "Faire Source ATC Shopping Loop Native",
    path: "/am/faire-source-atc-shopping-loop-native",
    description:
      "Native iOS app prototype of the PDP for the Faire Source ATC shopping loop flow.",
    owner: "Abby",
    createdAt: "2026-02-19",
    lastUpdated: "2026-02-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f9d1e4bef7442a48ce076b1cea4e2c29926897b101dab512a149e4cf283188e8.png",
    project: "ATC Shopping Loops",
    figmaLink:
      "https://www.figma.com/design/aT7aCzjftm3ojYiYkaoKvA/%F0%9F%AA%B5-Faire-Source--Post-MVP?node-id=12261-179832&m=dev",
    creationTool: "cursor",
  },
  {
    id: "updated-native-atc-shopping-loop",
    name: "Updated native ATC Shopping Loop",
    path: "/am/updated-native-atc-shopping-loop",
    description:
      "Native-style PDP with HAY Recycled Colour Crate, ATC bottom sheet (sticky header or full-scroll variant), smooth open/close, and Faire Source recommendations.",
    owner: "Abby",
    createdAt: "2026-02-27",
    lastUpdated: "2026-04-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b5593bbd2059610a746826e1d5aba214c27382b6219c0bc8e9c86482faa9bf3d.png",
    project: "ATC Shopping Loops",
    creationTool: "cursor",
  },
  {
    id: "faire-source-atc-shopping-loop",
    name: "Faire Source ATC Shopping Loop",
    path: "/am/faire-source-atc-shopping-loop",
    description:
      "PDP with simplified side cart panel — no tab navigation, no compass icon in global nav.",
    owner: "Abby",
    createdAt: "2026-02-18",
    lastUpdated: "2026-04-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/cc8abab34dfdb7ea423601d0ec0cc973026bc4eea40c40b2e8a4a34db875f6cb.png",
    project: "ATC Shopping Loops",
    creationTool: "cursor",
  },
  {
    id: "atc-shopping-loop-end-to-end",
    name: "ATC Shopping Loop: Latest Interaction Models",
    path: "/am/atc-shopping-loop-end-to-end",
    description:
      "End-to-end ATC shopping loop with PDP, Faire Source shop page, and side cart interactions across 6 variants.",
    owner: "Abby",
    createdAt: "2026-02-26",
    lastUpdated: "2026-04-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b27833156c6a15e05adb69bace78c3746340231fc1418d7f59e47737b39299e9.png",
    project: "ATC Shopping Loops",
    creationTool: "cursor",
  },
  {
    id: "updated-atc-interaction",
    name: "Updated ATC Interaction",
    path: "/am/updated-atc-interaction",
    description:
      "Center-modal ATC flow with MoMA PDP (Creative Porcelain Mugs). Variants: Modal on modal, Progressive modal.",
    owner: "Abby",
    createdAt: "2026-03-02",
    lastUpdated: "2026-04-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d7d2596ca2cc8d893e8b0638f64d97d361d5dd6c17e88c561ab2c844e93aceff.png",
    project: "ATC Shopping Loops",
    creationTool: "cursor",
  },
  {
    id: "non-faire-source-atc-shopping-loop",
    name: "Non-Faire Source ATC Shopping Loop",
    path: "/am/non-faire-source-atc-shopping-loop",
    description: "PDP ATC shopping loop flow for non-Faire Source brands.",
    owner: "Abby",
    createdAt: "2026-02-13",
    lastUpdated: "2026-04-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/85f5b446b110661cdba0d31b9526d387fa914c273d21c0313237c76eb5ac13c5.png",
    project: "ATC Shopping Loops",
    creationTool: "cursor",
  },
  {
    id: "non-faire-source-atc-shopping-loop-native",
    name: "Non-Faire Source ATC Shopping Loop Native",
    path: "/am/non-faire-source-atc-shopping-loop-native",
    description:
      "Native iOS app prototype of the PDP ATC shopping loop flow for non-Faire Source brands.",
    owner: "Abby",
    createdAt: "2026-02-20",
    lastUpdated: "2026-02-20",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1729de4cc7543024ded9861248953d88d60627e28109302dec681eccf04b7b35.png",
    project: "ATC Shopping Loops",
    creationTool: "cursor",
  },
  {
    id: "faire-source-card",
    name: "Faire Source Card",
    path: "/am/faire-source-card",
    description:
      "PDP card component showing Faire Source minimum reached state with benefit bullets, cross-sell product tiles, and CTAs.",
    owner: "Abby",
    createdAt: "2026-02-13",
    lastUpdated: "2026-04-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/341d8f573085ffebc15a4a06eb1fedecdcfddb517fd00dc56bdef1336e2397d1.png",
    figmaLink:
      "https://www.figma.com/design/aT7aCzjftm3ojYiYkaoKvA/%F0%9F%AA%B5-Faire-Source--Post-MVP?node-id=12084-134146&m=dev",
    creationTool: "cursor",
  },
  {
    id: "am-nav-item-nux",
    name: "Nav item NUX",
    path: "/am/nav-item-nux",
    description: "",
    owner: "Abby Mills",
    createdAt: "2026-06-09",
    lastUpdated: "2026-06-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/caf21f08d2f0c4336c29d6363c61fa902533f3ddd11864ef51b04c4ffd178328.png",
    creationTool: "claude-code",
  },
  {
    id: "am-faire-source-cart-vision",
    name: "Faire Source Cart Vision",
    path: "/am/faire-source-cart-vision",
    description: "Faire Source cart organization with product spacing approach",
    owner: "Abby Mills",
    createdAt: "2026-07-01",
    lastUpdated: "2026-07-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f70c6fd1a7dfb14beb6f63813216396f80d097815d078cfad1f971843fcb464f.png",
    creationTool: "claude-code",
  },
  {
    id: "am-faire-source-checkout-upsell",
    name: "Faire Source Checkout Upsell",
    path: "/am/faire-source-checkout-upsell",
    description:
      "Checkout upsell that lets retailers add Faire Source items to an existing order",
    owner: "Abby Mills",
    createdAt: "2026-07-16",
    lastUpdated: "2026-07-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/am-faire-source-checkout-upsell.png",
    creationTool: "cursor",
  },
  {
    id: "am-quick-view-down-funnel",
    name: "Quick View Down Funnel",
    path: "/am/quick-view-down-funnel",
    description:
      "Exploring quick view entrypoints down-funnel, starting from the Faire Source checkout upsell 2-row flow",
    owner: "Abby Mills",
    createdAt: "2026-07-29",
    lastUpdated: "2026-07-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f1335e54c046e390df3e420e4eb7f544cae3b43ddd6e076731253687c03988c3.png",
    creationTool: "cursor",
  },
  {
    id: "am-faire-source-cart-refresh",
    name: "Faire Source Cart Refresh",
    path: "/am/faire-source-cart-refresh",
    description:
      "Baseline replica of the multi-brand Faire Source cart, with above- and below-minimum states, plus a list cell playground for product row explorations",
    owner: "Abby Mills",
    createdAt: "2026-08-18",
    lastUpdated: "2026-09-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/am-faire-source-cart-refresh.png",
    creationTool: "claude-code",
  },
  {
    id: "am-faire-source-cart-ios",
    name: "Faire Source Cart Refresh (mobile)",
    path: "/am/faire-source-cart-ios",
    description:
      "Pixel-accurate iOS mock of the Faire Source multi-brand cart, grouped by brand with select mode, removed items, and Faire Source recommendations",
    owner: "Abby Mills",
    createdAt: "2026-09-29",
    lastUpdated: "2026-09-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    creationTool: "cursor",
    figmaLink:
      "https://www.figma.com/design/grGsiL5CwYU3HZNeuLBFu1/%F0%9F%9B%92-Faire-Source-Cart-2026?node-id=9090-62602&m=dev",
    thumbnail: "/images/thumbnails/am-faire-source-cart-ios.png",
  },
];
